var WebSocketErrorEnum;
(function (WebSocketErrorEnum) {
    WebSocketErrorEnum["NOT_AVAILABLE"] = "WEBSOCKET_NOT_AVAILABLE";
    WebSocketErrorEnum["CONNECTION"] = "WEBSOCKET_CONNECTION_ERROR";
})(WebSocketErrorEnum || (WebSocketErrorEnum = {}));
export { WebSocketErrorEnum };
//# sourceMappingURL=websocket-error.enumeration.js.map